var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error-icon",
    transform: "translate(-573 -496)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2733",
    "data-name": "Ellipse 2733",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(573 496)",
    fill: "#f96065",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12563",
    "data-name": "Group 12563",
    transform: "translate(578.744 501.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "checked",
    d: "M3.878,73.089,5.124,74.35l8.686-8.677-1.247-1.23-7.439,7.43h0Z",
    transform: "translate(-3.878 -64.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "checked-2",
    "data-name": "checked",
    d: "M13.81,73.089,12.564,74.35,3.878,65.673l1.247-1.23,7.439,7.43h0Z",
    transform: "translate(-3.878 -64.443)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.931405c7.svg";
export { ForwardRef as ReactComponent };